       
theme.variantSelected = function(variant, selector) {
       
        var actual_price, compare_price, variant_image_index;
        $(".compare-price").html("");
        if (variant && variant.available) {
          $(".quanity-cart-row").show();
          $('.product-unavailable').hide();
        } else {
          $(".quanity-cart-row").hide();
          $('.product-unavailable').show();
          $('.product-low-in-stock').hide();
          if (product_variant_size > 1 && variant) {
            $('.product-unavailable form .email-body').attr('value', 'Please notify me when this is back in stock: ' + product_title + ' - ' + variant.title);
          }
        }
        if (variant) {
          actual_price = Shopify.formatMoney(variant.price, shop_money_format);
          $(".actual-price").replaceWith('<span class="actual-price money" itemprop="price">' + actual_price + '</span>');
          if (variant.compare_at_price > variant.price) {
            compare_price = Shopify.formatMoney(variant.compare_at_price, shop_money_format);
            $(".compare-price").html(product_language_was + ' <span class="money">' + compare_price + '</span>');
          }
          
          if (currency_switcher_enabled) {
            Currency.convertAll(shopCurrency, jQuery('[name=currencies]').val());
          }
      
          if (variant.featured_image) {
            variant_image_index = $('article .photos .photo[data-image-id="' + variant.featured_image.id + '"]').index();
            updateActiveImg(variant_image_index);
          } else {
            updateActiveImg(0);
          }
          
          if ($('.size-chart').length > 0 && $('.size-chart-trigger').length < 1) {
            $('.cart-form').addClass('size-chart-enabled');
            $('.selector-wrapper').each(function() {
              var $selector_wrapper;
              $selector_wrapper = $(this);
              if ($selector_wrapper.find('label').text().toLowerCase() === theme.product_size_chart_option) {
                return $selector_wrapper.append('<a class="size-chart-trigger" href="#">' + theme.size_chart_label + '</a>');
              }
            });
          }
          if (theme.product_low_in_stock.show === true && variant.inventory_management === "shopify") {
            updateLowInStock(variant);
          }
        }
      };